import React from "react";
import { BasicChequeredBoard } from "../../components/BasicChequeredBoard";
import { BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";

export interface TempServiceLineDisconnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  chequeredBoard?: BasicChequeredBoardProps;
  processes?: ProcessStepsProps[];
  wantToReport?: GreyCardProps;
  faqs?: FaqAccordionGroupProps;
  responsibilities?: ResponsibilitiesProps[];
}

export const TempServiceLineDisconnectionPage: React.FC<TempServiceLineDisconnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  chequeredBoard,
  processes,
  wantToReport,
  faqs,
  responsibilities,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
    </ServiceCataloguePageWrapper>
  );
};
